module.exports = __webpack_public_path__ + "img/IMG_2671_L_Black_MockedUp.fa7c8b5d.jpg";